import { Button } from '@/components/ui/button';
import { Language as LanguageIcon, Setting } from '@/widget/Icon';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useTheme } from '@/components/ThemeProvider';
import { Moon } from 'lucide-react';
import { useThemeAnimate } from '@/hooks/base/useThemeAnimate';
import { Switch } from '@/components/ui/switch';
import { LangEnum } from '@/lang/enum';
import useLang from '@/hooks/base/useLang';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@/store';

export default () => {
  const { lang } = useAppStore();
  const { t } = useTranslation();
  const { theme } = useTheme();
  const { toggleTheme } = useThemeAnimate();
  const { updateLanguage } = useLang();

  const onToggleLang = (e: LangEnum) => {
    updateLanguage(e);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="flex items-center justify-center">
          <Setting className="!w-[24px] !h-[24px]" theme={theme} />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-[185px]">
        <DropdownMenuGroup>
          <DropdownMenuSub>
            <DropdownMenuSubTrigger>
              <Button className="w-[16px] h-[16px]" variant="outline" size="icon">
                <LanguageIcon className="w-[18px] h-[18px]" theme={theme} />
              </Button>
              <span>{t('Header.language')}</span>
            </DropdownMenuSubTrigger>
            <DropdownMenuPortal>
              <DropdownMenuSubContent>
                <DropdownMenuCheckboxItem checked={lang == LangEnum.EN} onCheckedChange={() => onToggleLang(LangEnum.EN)}>
                  <span>English</span>
                </DropdownMenuCheckboxItem>
                <DropdownMenuCheckboxItem checked={lang == LangEnum.ZH_CN} onCheckedChange={() => onToggleLang(LangEnum.ZH_CN)}>
                  <span>简体中文</span>
                </DropdownMenuCheckboxItem>
                <DropdownMenuCheckboxItem checked={lang == LangEnum.ZH_HK} onCheckedChange={() => onToggleLang(LangEnum.ZH_HK)}>
                  <span>繁体中文</span>
                </DropdownMenuCheckboxItem>
              </DropdownMenuSubContent>
            </DropdownMenuPortal>
          </DropdownMenuSub>
          <DropdownMenuSub>
            <DropdownMenuItem onClick={(e) => toggleTheme(e)}>
              <Button className="rounded-[8px] w-[16px] h-[16px] relative" variant="ghost" size="icon" onClick={toggleTheme}>
                <Moon className="h-[1.2rem] w-[1.2rem] bg-#fff light:bg-[#000]" />
              </Button>
              <span className="text-[14px]">{t('Header.darkMode')}</span>
              <DropdownMenuShortcut className="opacity-100">
                <Switch
                  dotClass="dark:bg-[#fff]"
                  className="dark:data-[state=checked]:bg-buyColor data-[state=checked]:bg-buyColor"
                  checked={theme === 'dark'}
                />
              </DropdownMenuShortcut>
            </DropdownMenuItem>
          </DropdownMenuSub>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
